var _ = require('underscore')
  , urlUtils = require('@173js/url')
  , EMPTY = '0'

var commonParamKeys = [
  "game_frame"
, "charge_mode"
, "test_status"
, "game_type"
, "game_theme"
, "star_level"
, "game_area"
, "game_feature"
]

var defaultParamKeys = commonParamKeys.concat([
  "game_style"
, "fight_mode"
, "sortord"
, "view_type"
, "game_kind"
, "game_platform"
])

var defaultParamKeysWhenTenParam = commonParamKeys.concat([
  "sortord"
, "view_type"
])

function createGameList(params) {

  var targetParamValues = []
    , DEFAULT_SORT = '3'
    , DEFAULT_VIEW_TYPE = '2'

  _.each(defaultParamKeys, function(defaultParam) {
    var targetParam = params[defaultParam]

    if (!targetParam && defaultParam === 'sortord') {
      targetParam = DEFAULT_SORT
    } else if (!targetParam && defaultParam === 'view_type') {
      targetParam = DEFAULT_VIEW_TYPE
    } else if (!targetParam) {
      targetParam = EMPTY
    }

    targetParamValues.push(targetParam)
  })

  var keywordParams = urlUtils.getURLParameters(window.location.search)
  ;delete keywordParams.page;

  if (!$.isEmptyObject(keywordParams)) {
    return '/game-list-' + targetParamValues.join('-') + '.html?keyword='+keywordParams.keyword+''
  }

  return '/game-list-' + targetParamValues.join('-') + '.html'
}

var rParamValueArray = /\/game-list(.*)\.html/
  , PARAMS_LENGTH_IS_TEN = 10

function getUrlParams(pathname) {
  var matched = pathname.match(rParamValueArray)

  if (!matched) { return {} }
  var paramValueArray =
        _.filter(matched[1].split('-'), function(value) { return !!value })
    , params = {}

  var paramKeys = paramValueArray.length === PARAMS_LENGTH_IS_TEN
    ? defaultParamKeysWhenTenParam : defaultParamKeys

  _.each(paramValueArray, function(value, index) {
    params[paramKeys[index]] = value
  })

  return params
}

exports.getUrlParams = function(params) {
  return getUrlParams(window.location.pathname)
}

exports.getNavClass = function(params) {
  var urlParams = this.urlParams
    , isCurrent = _.every(
        _.map(params, function(param, paramKey) {
          param = '' + param

          return param === urlParams[paramKey] ||
            param === EMPTY && !urlParams[paramKey]
        })
      )

  return isCurrent ? 'current' : ''
}

exports.getFilterUrl = function(params) {
  params = _.extend(_.clone(this.urlParams), params)

  return createGameList(params)
}
